import React, { Component } from "react";

import { Row, Col, Card } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import LazyLoad from "react-lazyload";
import phoneIcon from "../../Imgs/HomePage/hpPhone.png";
// CSS Files
import "../../Fonts/Fonts.css";
import "../../Statics/HomePage/Companies.css";
import "../../Statics/HomePage/TextAutoplay.css";

const gridStyle = {
  width: "25%",
  textAlign: "center",
  maxHeight: "auto",
  padding: 0,
  paddingTop: "10px",
  Margin: 0,
};
const gridStyleTablet = {
  width: "33.33%",
  textAlign: "center",
  maxHeight: "auto",
  padding: 0,
  paddingTop: "10px",
  Margin: 0,
};
const gridStyleMobile = {
  width: "50%",
  textAlign: "center",
  maxHeight: "auto",
  padding: 0,
  paddingTop: "10px",
  Margin: 0,
};
const bottomCardStyleRight = {
  width: "25%",
  textAlign: "center",
  maxHeight: "auto",
  padding: 0,
  paddingTop: "10px",
  Margin: 0,
  borderRadius: "0 0 10px 0",
};
const bottomCardStyleRightTablet = {
  width: "33.33%",
  textAlign: "center",
  maxHeight: "auto",
  padding: 0,
  paddingTop: "10px",
  Margin: 0,
  borderRadius: "0 0 10px 0",
};
const bottomCardStyleRightMobile = {
  width: "50%",
  textAlign: "center",
  maxHeight: "auto",
  padding: 0,
  paddingTop: "10px",
  Margin: 0,
  borderRadius: "0 0 10px 0",
};
const bottomCardStyleLeft = {
  width: "25%",
  textAlign: "center",
  maxHeight: "auto",
  padding: 0,
  paddingTop: "10px",
  Margin: 0,
  borderRadius: "0 0 0 10px",
};
const bottomCardStyleLeftTablet = {
  width: "33.33%",
  textAlign: "center",
  maxHeight: "auto",
  padding: 0,
  paddingTop: "10px",
  Margin: 0,
  borderRadius: "0 0 0 10px",
};
const bottomCardStyleLeftMobile = {
  width: "50%",
  textAlign: "center",
  maxHeight: "auto",
  padding: 0,
  paddingTop: "10px",
  Margin: 0,
  borderRadius: "0 0 0 10px",
};

const companyTextDesk = {
  color: "#253D4B",
  fontSize: ".85em",
  marginTop: "-15px",
};

const mainCard = {
  fontFamily: "IRANSans",
  textAlign: "center",
  direction: "rtl",
  borderRadius: "10px",
  boxShadow: "0 4px 8px 0 rgb(0,0,0,.02),0 6px 20px 0 rgb(0,0,0,.19)",
};

const autoplayText = {
  fontFamily: "IRANSans",
  color: "#ffffff",
  textAlign: "right",
  direction: "rtl",
  fontSize: "1em",
};
const autoplayTextMobile = {
  fontFamily: "IRANSans",
  color: "#ffffff",
  textAlign: "center",
  direction: "rtl",
  fontSize: ".9em",
};
const logoStyle = {
  width: "40%",
};
const Companies = (props) => {
  return props.size === "laptopdesktop" ? (
    <div>
      <Row style={{ marginTop: "-10px" }}>
        <Col span={2}></Col>
        <Col span={9}>
          <Margin top={4}>
            <Card style={mainCard} title="شرکت های زیرمجموعه">
              <Card.Grid style={gridStyle}>
                <a href="http://sanaap.com/" target="_blank">
                  <Center>
                    <div>
                      <figure>
                        <LazyLoad>
                          <img
                            style={logoStyle}
                            src={require("../../Imgs/CompaniesLogo/company4.png")}
                          />
                        </LazyLoad>
                      </figure>
                    </div>
                  </Center>
                  <Center>
                    <p style={companyTextDesk}>سناپ</p>
                  </Center>
                </a>
              </Card.Grid>
              <Card.Grid style={gridStyle}>
                <a href="https://moraghebbime.com/homepage" target="_blank">
                  <Center>
                    <div>
                      <figure>
                        <LazyLoad>
                          <img
                            style={logoStyle}
                            src={require("../../Imgs/CompaniesLogo/company3.png")}
                          />
                        </LazyLoad>
                      </figure>
                    </div>
                  </Center>
                  <Center>
                    <p style={companyTextDesk}>رسانه خبری مراقب بیمه</p>
                  </Center>
                </a>
              </Card.Grid>
              <Card.Grid style={gridStyle}>
                <a href="http://andishkadebime.ir/" target="_blank">
                  <Center>
                    <div>
                      <figure>
                        <LazyLoad>
                          <img
                            style={logoStyle}
                            src={require("../../Imgs/CompaniesLogo/company2.png")}
                          />
                        </LazyLoad>
                      </figure>
                    </div>
                  </Center>
                  <Center>
                    <p style={companyTextDesk}>اندیشکده بیمه</p>
                  </Center>
                </a>
              </Card.Grid>
              <Card.Grid style={gridStyle}>
                <a href="http://arzyabip.com/" target="_blank">
                  <Center>
                    <div>
                      <figure>
                        <LazyLoad>
                          <img
                            style={logoStyle}
                            src={require("../../Imgs/CompaniesLogo/company1.png")}
                          />
                        </LazyLoad>
                      </figure>
                    </div>
                  </Center>
                  <Center>
                    <p style={companyTextDesk}>ارزیابان ایرانیان پوشش</p>
                  </Center>
                </a>
              </Card.Grid>
              <Card.Grid style={gridStyle}>
                <a href="https://dadrasbime.ir/" target="_blank">
                  <Center>
                    <div>
                      <figure>
                        <LazyLoad>
                          <img
                            style={logoStyle}
                            src={require("../../Imgs/CompaniesLogo/company8.png")}
                          />
                        </LazyLoad>
                      </figure>
                    </div>
                  </Center>
                  <Center>
                    <p style={companyTextDesk}>دادرس بیمه</p>
                  </Center>
                </a>
              </Card.Grid>
              <Card.Grid style={gridStyle}>
                <a href="http://kankashbimeh.ir/" target="_blank">
                  <Center>
                    <div>
                      <figure>
                        <LazyLoad>
                          <img
                            style={logoStyle}
                            src={require("../../Imgs/CompaniesLogo/company7.png")}
                          />
                        </LazyLoad>
                      </figure>
                    </div>
                  </Center>
                  <Center>
                    <p style={companyTextDesk}>کنکاش بیمه</p>
                  </Center>
                </a>
              </Card.Grid>
              <Card.Grid style={gridStyle}>
                <a href="http://hamiarbime.ir/" target="_blank">
                  <Center>
                    <div>
                      <figure>
                        <LazyLoad>
                          <img
                            style={logoStyle}
                            src={require("../../Imgs/CompaniesLogo/company6.png")}
                          />
                        </LazyLoad>
                      </figure>
                    </div>
                  </Center>
                  <Center>
                    <p style={companyTextDesk}>همیار بیمه</p>
                  </Center>
                </a>
              </Card.Grid>
              <Card.Grid style={gridStyle}>
                <a href="http://dadgarbime.ir/" target="_blank">
                  <Center>
                    <div>
                      <figure>
                        <LazyLoad>
                          <img
                            style={logoStyle}
                            src={require("../../Imgs/CompaniesLogo/company5.png")}
                          />
                        </LazyLoad>
                      </figure>
                    </div>
                  </Center>
                  <Center>
                    <p style={companyTextDesk}>دادگر بیمه</p>
                  </Center>
                </a>
              </Card.Grid>
              <Card.Grid style={bottomCardStyleLeft}>
                <a href="http://ipteach.ir/" target="_blank">
                  <Center>
                    <div>
                      <figure>
                        <LazyLoad>
                          <img
                            style={logoStyle}
                            src={require("../../Imgs/CompaniesLogo/company12.png")}
                          />
                        </LazyLoad>
                      </figure>
                    </div>
                  </Center>
                  <Center>
                    <p className="" style={companyTextDesk}>
                      آموزشگاه فنی و حرفه ای
                    </p>
                  </Center>
                </a>
              </Card.Grid>
              <Card.Grid style={gridStyle}>
                <a href="https://separ.info/" target="_blank">
                  <Center>
                    <div>
                      <figure>
                        <LazyLoad>
                          <img
                            style={logoStyle}
                            src={require("../../Imgs/CompaniesLogo/company1.png")}
                          />
                        </LazyLoad>
                      </figure>
                    </div>
                  </Center>
                  <Center>
                    <p style={companyTextDesk}>سپر</p>
                  </Center>
                </a>
              </Card.Grid>
              <Card.Grid style={gridStyle}>
                <a href="https://emdadpooshesh.com/" target="_blank">
                  <Center>
                    <div>
                      <figure>
                        <LazyLoad>
                          <img
                            style={logoStyle}
                            src={require("../../Imgs/CompaniesLogo/company10.svg")}
                          />
                        </LazyLoad>
                      </figure>
                    </div>
                  </Center>
                  <Center>
                    <p style={companyTextDesk}>امداد و نجات</p>
                  </Center>
                </a>
              </Card.Grid>
              <Card.Grid style={bottomCardStyleRight}>
                <a href="https://www.azhansbime.com/" target="_blank">
                  <Center>
                    <div>
                      <figure>
                        <LazyLoad>
                          <img
                            style={logoStyle}
                            src={require("../../Imgs/CompaniesLogo/company9.png")}
                          />
                        </LazyLoad>
                      </figure>
                    </div>
                  </Center>
                  <Center>
                    <p style={companyTextDesk}>آژانس بیمه</p>
                  </Center>
                </a>
              </Card.Grid>
            </Card>
          </Margin>
        </Col>
        <Col span={1}></Col>
        <Col
          span={8}
          style={{ direction: "rtl", textAlign: "right", marginTop: "50px" }}
        >
          <Row>
            <h4
              style={{
                fontFamily: "IRANSans",
                color: "#fff",
                textAlign: "right",
                direction: "rtl",
              }}
            >
              <strong>ایستگاه نوآوری صنعت بیمه - منهای فروش</strong>
            </h4>
          </Row>
          <Row>
            <strong
              style={{
                fontFamily: "IRANSans",
                color: "#fff",
                textAlign: "right",
                direction: "rtl",
                marginTop: "5px",
                fontSize: "1.3em",
              }}
            >
              نخستین شرکت ارزیابی ریسک و خسارت بیمه ای
            </strong>
          </Row>
          <Margin top={3}></Margin>
          <Row>
            <Col span={6}>
              <strong
                style={{
                  fontFamily: "IRANSans",
                  color: "#fff",
                  textAlign: "right",
                  direction: "rtl",
                  fontSize: "1.05em",
                }}
              >
                شرکت های ما:
              </strong>
            </Col>
            <Col span={18}>
              <div class="autoplayTexts">
                <div class="autoplayText active">
                  <p style={autoplayText}>ارزیابی خسارت ، ریسک ، ایمنی و TPA</p>
                </div>
                <div class="autoplayText">
                  <p style={autoplayText}>
                    حقوقی، داوری ، وکالت ، مشاوره و خسارت
                  </p>
                </div>
                <div class="autoplayText">
                  <p style={autoplayText}>
                    آکچوئری، داده کاوی، طراحی محصول بیمه ای
                  </p>
                </div>
                <div class="autoplayText">
                  <p style={autoplayText}>
                    آموزش ، پژوهش ، حسابرسی ، فناوری اطلاعات
                  </p>
                </div>
                <div class="autoplayText">
                  <p style={autoplayText}>
                    بازرسی، تحقیق ، رسانه ، امداد و نجات و خدمات CIP
                  </p>
                </div>
              </div>
            </Col>
          </Row>
          <hr
            style={{
              border: "1px solid #fff",
              opacity: "65%",
              marginTop: "17.5px",
            }}
          />
          <Row style={{ marginLeft: "17.5px" }}>
            <Col span={7}></Col>
            <Col span={10}>
              <Row>
                <h5
                  style={{
                    fontFamily: "IRANSans",
                    color: "#4983C4",
                    textAlign: "right",
                    direction: "rtl",
                  }}
                >
                  <strong>با ما تماس بگیرید</strong>
                </h5>
              </Row>
              <Row>
                <p
                  style={{
                    fontFamily: "IRANSans",
                    color: "#fff",
                    textAlign: "right",
                    direction: "rtl",
                    fontSize: "1.08em",
                    opacity: "85%",
                  }}
                >
                  پاسخگویی 24 ساعته
                </p>
              </Row>
            </Col>
            <Col span={4}>
              <Row>
                <h2
                  style={{
                    fontFamily: "IRANSans",
                    color: "#fff",
                    textAlign: "right",
                    direction: "rtl",
                  }}
                >
                  <strong>1401</strong>
                </h2>
              </Row>
              <Row>
                <h6
                  style={{
                    fontFamily: "IRANSans",
                    color: "#fff",
                    textAlign: "right",
                    direction: "rtl",
                    marginTop: "-10px",
                  }}
                >
                  <strong>بدون کد</strong>
                </h6>
              </Row>
            </Col>
            <Col span={3}>
              <img
                style={{ width: "90px", marginTop: "-15px" }}
                src={require("../../Imgs/HomePage/hpPhone.png")}
                alt=""
              />
            </Col>
          </Row>
        </Col>
        <Col span={4}></Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
    <div>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <Row style={{ textAlign: "right", direction: "rtl" }}>
            <p
              style={{
                fontFamily: "IRANSans",
                color: "#fff",
                textAlign: "right",
                direction: "rtl",
                fontSize: "1.1em",
              }}
            >
              <strong>ایستگاه نوآوری صنعت بیمه - منهای فروش</strong>
            </p>
          </Row>
          <Row style={{ textAlign: "right", direction: "rtl" }}>
            <p
              style={{
                fontFamily: "IRANSans",
                color: "#fff",
                textAlign: "right",
                direction: "rtl",
                marginTop: "-5px",
                fontSize: "1em",
              }}
            >
              <strong>نخستین شرکت ارزیابی ریسک و خسارت بیمه ای</strong>
            </p>
          </Row>
          <Row style={{ marginTop: "-10px" }}>
            <Col span={24}>
              <div class="autoplayTexts">
                <div class="autoplayText active">
                  <p style={autoplayText}>ارزیابی خسارت ، ریسک ، ایمنی و TPA</p>
                </div>
                <div class="autoplayText">
                  <p style={autoplayText}>
                    حقوقی، داوری ، وکالت ، مشاوره و خسارت
                  </p>
                </div>
                <div class="autoplayText">
                  <p style={autoplayText}>
                    آکچوئری، داده کاوی، طراحی محصول بیمه ای
                  </p>
                </div>
                <div class="autoplayText">
                  <p style={autoplayText}>
                    آموزش ، پژوهش ، حسابرسی ، فناوری اطلاعات
                  </p>
                </div>
                <div class="autoplayText">
                  <p style={autoplayText}>
                    بازرسی، تحقیق ، رسانه ، امداد و نجات و خدمات CIP
                  </p>
                </div>
              </div>
            </Col>
          </Row>
          <hr
            style={{
              border: "1px solid #fff",
              opacity: "65%",
              marginTop: "17.5px",
            }}
          />
          <Row style={{ marginLeft: "17.5px" }}>
            <Col span={3}>
              <img
                style={{ width: "80px", marginTop: "-20px" }}
                src={require("../../Imgs/HomePage/hpPhone.png")}
                alt=""
              />
            </Col>
            <Col span={2}></Col>
            <Col span={5}>
              <Row>
                <h2
                  style={{
                    fontFamily: "IRANSans",
                    color: "#fff",
                    textAlign: "right",
                    direction: "rtl",
                    marginTop: "-10px",
                  }}
                >
                  <strong>1401</strong>
                </h2>
              </Row>
              <Row>
                <h6
                  style={{
                    fontFamily: "IRANSans",
                    color: "#fff",
                    textAlign: "right",
                    direction: "rtl",
                    marginTop: "-10px",
                  }}
                >
                  <strong>بدون کد</strong>
                </h6>
              </Row>
            </Col>
            <Col span={9}>
              <Row>
                <p
                  style={{
                    fontFamily: "IRANSans",
                    color: "#4983c4",
                    textAlign: "right",
                    direction: "rtl",
                    marginTop: "-5px",
                    fontSize: "1.15em",
                  }}
                >
                  <strong>با ما تماس بگیرید</strong>
                </p>
              </Row>
              <Row>
                <p
                  style={{
                    fontFamily: "IRANSans",
                    color: "#fff",
                    textAlign: "right",
                    direction: "rtl",
                    fontSize: "1em",
                    opacity: "85%",
                    marginTop: "-10px",
                  }}
                >
                  پاسخگویی 24 ساعته
                </p>
              </Row>
            </Col>
            <Col span={5}></Col>
          </Row>
        </Col>
        <Col span={2}></Col>
      </Row>
      <Margin top={4}></Margin>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <Card style={mainCard} title="شرکت های زیرمجموعه">
            <Card.Grid style={gridStyleTablet}>
              <a href="https://moraghebbime.com/homepage" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company3.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>رسانه خبری مراقب بیمه</p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleTablet}>
              <a href="http://andishkadebime.ir/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company2.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>اندیشکده بیمه</p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleTablet}>
              <a href="http://arzyabip.com/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company1.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>ارزیابان ایرانیان پوشش</p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleTablet}>
              <a href="http://hamiarbime.ir/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company6.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>همیار بیمه</p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleTablet}>
              <a href="http://dadgarbime.ir/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company5.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>دادگر بیمه</p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleTablet}>
              <a href="http://sanaap.com/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company4.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>سناپ</p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleTablet}>
              <a href="https://www.azhansbime.com/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company9.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>آژانس بیمه</p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleTablet}>
              <a href="https://dadrasbime.ir/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company8.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>دادرس بیمه</p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleTablet}>
              <a href="http://kankashbimeh.ir/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company7.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>کنکاش بیمه</p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleTablet}>
              <a href="http://ipteach.ir/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company12.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p className="" style={companyTextDesk}>
                    آموزشگاه فنی و حرفه ای
                  </p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleTablet}>
              <a href="https://separ.info/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company1.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>سپر</p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleTablet}>
              <a href="https://emdadpooshesh.com/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company10.svg")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>امداد و نجات</p>
                </Center>
              </a>
            </Card.Grid>
          </Card>
        </Col>
        <Col span={2}></Col>
      </Row>
    </div>
  ) : (
    <div>
      <div className="homePageBackground">
        <Center>
          <p
            style={{
              fontFamily: "IRANSansBold",
              color: "#fff",
              textAlign: "right",
              direction: "rtl",
              fontSize: "1.1em",
              marginTop: "20px",
            }}
          >
            <strong>ایستگاه نوآوری صنعت بیمه - منهای فروش</strong>
          </p>
        </Center>
        <Center>
          <p
            style={{
              fontFamily: "IranSans",
              color: "#fff",
              textAlign: "right",
              direction: "rtl",
              marginTop: "-2.5px",
              fontSize: ".95em",
            }}
          >
            <strong>نخستین شرکت ارزیابی ریسک و خسارت بیمه ای</strong>
          </p>
        </Center>
        <Row>
          <Col span={2}></Col>
          <Col span={20}>
            <div class="autoplayTexts" style={{ textAlign: "center" }}>
              <div class="autoplayText active">
                <p style={autoplayTextMobile}>
                  ارزیابی خسارت ، ریسک ، ایمنی و TPA
                </p>
              </div>
              <div class="autoplayText">
                <p style={autoplayTextMobile}>
                  حقوقی، داوری ، وکالت ، مشاوره و خسارت
                </p>
              </div>
              <div class="autoplayText">
                <p style={autoplayTextMobile}>
                  آکچوئری، داده کاوی، طراحی محصول بیمه ای
                </p>
              </div>
              <div class="autoplayText">
                <p style={autoplayTextMobile}>
                  آموزش ، پژوهش ، حسابرسی ، فناوری اطلاعات
                </p>
              </div>
              <div class="autoplayText">
                <p style={autoplayTextMobile}>
                  بازرسی، تحقیق ، رسانه ، امداد و نجات و خدمات CIP
                </p>
              </div>
            </div>
          </Col>
          <Col span={2}></Col>
        </Row>
        <Margin top={4}></Margin>
        <Row>
          <Col span={1}></Col>
          <Col span={22}>
            <Row>
              <Col span={12}>
                <Row>
                  <Col span={4}>
                    <a href="tel:1401">
                      <img
                        style={{ width: "75px", marginTop: "-15px" }}
                        src={phoneIcon}
                        alt=""
                      />
                    </a>
                  </Col>
                  <Col
                    span={20}
                    style={{ direction: "rtl", textAlign: "center" }}
                  >
                    <Row>
                      <p
                        style={{
                          fontFamily: "IRANSansBold",
                          color: "#fff",
                          textAlign: "right",
                          direction: "rtl",
                          fontSize: "1.5em",
                          opacity: "85%",
                          marginTop: "-7.5px",
                        }}
                      >
                        <a href="tel:1401" style={{ color: "#fff" }}>
                          <strong>1401</strong>
                        </a>
                      </p>
                    </Row>
                    <Row>
                      <p
                        style={{
                          fontFamily: "IRANSans",
                          color: "#fff",
                          textAlign: "right",
                          direction: "rtl",
                          fontSize: ".9em",
                          opacity: "85%",
                          marginTop: "-15px",
                        }}
                      >
                        <strong>بدون کد</strong>
                      </p>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col span={12} style={{ direction: "rtl", textAlign: "right" }}>
                <Row>
                  <p
                    style={{
                      fontFamily: "IRANSans",
                      color: "#4983C4",
                      textAlign: "right",
                      direction: "rtl",
                      fontSize: ".95em",
                    }}
                  >
                    <strong>با ما تماس بگیرید</strong>
                  </p>
                </Row>
                <Row>
                  <p
                    style={{
                      fontFamily: "IRANSans",
                      color: "#fff",
                      textAlign: "right",
                      direction: "rtl",
                      fontSize: ".9em",
                      opacity: "85%",
                      marginTop: "-10px",
                    }}
                  >
                    پاسخگویی 24 ساعته
                  </p>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col span={1}></Col>
        </Row>
      </div>

      <Row style={{marginTop:"-250px"}}>
        <Col span={1}></Col>
        <Col span={22}>
          <Card style={mainCard} title="شرکت های زیرمجموعه">
            <Card.Grid style={gridStyleMobile}>
              <a href="https://moraghebbime.com/homepage" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company3.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>رسانه خبری مراقب بیمه</p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleMobile}>
              <a href="http://arzyabip.com/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company1.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>ارزیابان ایرانیان پوشش</p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleMobile}>
              <a href="http://andishkadebime.ir/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company2.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>اندیشکده بیمه</p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleMobile}>
              <a href="http://sanaap.com/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company4.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>سناپ</p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleMobile}>
              <a href="http://hamiarbime.ir/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company6.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>همیار بیمه</p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleMobile}>
              <a href="http://dadgarbime.ir/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company5.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>دادگر بیمه</p>
                </Center>
              </a>
            </Card.Grid>
           
            <Card.Grid style={gridStyleMobile}>
              <a href="https://www.azhansbime.com/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company9.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>آژانس بیمه</p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleMobile}>
              <a href="https://dadrasbime.ir/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company8.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>دادرس بیمه</p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleMobile}>
              <a href="http://kankashbimeh.ir/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company7.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>کنکاش بیمه</p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleMobile}>
              <a href="http://ipteach.ir/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company12.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p className="" style={companyTextDesk}>
                    آموزشگاه فنی و حرفه ای
                  </p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleMobile}>
              <a href="https://separ.info/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company1.png")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>سپر</p>
                </Center>
              </a>
            </Card.Grid>
            <Card.Grid style={gridStyleMobile}>
              <a href="https://emdadpooshesh.com/" target="_blank">
                <Center>
                  <div>
                    <figure>
                      <LazyLoad>
                        <img
                          style={logoStyle}
                          src={require("../../Imgs/CompaniesLogo/company10.svg")}
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </Center>
                <Center>
                  <p style={companyTextDesk}>امداد و نجات</p>
                </Center>
              </a>
            </Card.Grid>
          </Card>
        </Col>
        <Col span={1}></Col>
      </Row>
    </div>
  );
};

export default Companies;
